export default {
 proxyCookies: true,
 clientAwareness: false,
 cookieAttributes: {"maxAge":604800,"secure":true},
 clients: {"default":{"httpEndpoint":"https://graphql.datocms.com/","tokenName":"apollo:default.token","tokenStorage":"cookie","authType":null,"authHeader":"Authorization"}}
}